<div class="spotlight" [class.is-open]="isPanelOpen()" (focusout)="onFocusOut($event)">
  <div class="spotlight-field d-flex align-items-center">
    <mat-icon class="field-icon">search</mat-icon>

    <input #field type="text" class="field-input flex-grow-1" role="combobox" autocomplete="off"
      spellcheck="false" [attr.aria-label]="'app.home.spotlight.placeholder' | translate"
      [attr.aria-expanded]="isPanelOpen()" [attr.aria-controls]="panelId" aria-autocomplete="list"
      [attr.aria-activedescendant]="highlightedKey().length > 0 ? panelId + '-active' : null"
      [placeholder]="'app.home.spotlight.placeholder' | translate" [value]="spotlight.query()"
      (input)="onInput(field.value)" (focus)="onFocus()" />

    @if (spotlight.isSearching()) {
    <mat-progress-spinner class="field-spinner" mode="indeterminate" diameter="18" />
    }

    @if (spotlight.hasQuery()) {
    <button type="button" mat-icon-button class="field-clear"
      [matTooltip]="'app.home.spotlight.clear' | translate" (click)="clear()">
      <mat-icon>close</mat-icon>
    </button>
    } @else {
    <span class="field-shortcut" aria-hidden="true">{{ shortcutLabelKey() | translate }}</span>
    }
  </div>

  @if (isPanelOpen()) {
  <div class="spotlight-panel" role="listbox" [id]="panelId"
    [attr.aria-label]="'app.home.spotlight.placeholder' | translate">
    @for (group of groups(); track group.titleKey) {
    <div class="panel-group" role="group" [attr.aria-label]="group.titleKey | translate">
      <span class="group-title" aria-hidden="true">{{ group.titleKey | translate }}</span>

      @for (entry of group.entries; track entry.key) {
      <a class="panel-entry d-flex align-items-center" role="option"
        [id]="entry.key === highlightedKey() ? panelId + '-active' : optionId(entry)"
        [class.is-highlighted]="entry.key === highlightedKey()"
        [attr.aria-selected]="entry.key === highlightedKey()" [routerLink]="entry.routerLink"
        (click)="select()">
        <mat-icon class="entry-icon flex-shrink-0">{{ entry.icon }}</mat-icon>
        <span class="entry-text d-flex flex-column min-w-0">
          <span class="entry-label text-truncate">{{ entry.label }}</span>
          @if (entry.hint.length > 0) {
          <span class="entry-hint text-truncate">{{ entry.hint }}</span>
          }
        </span>
        <mat-icon class="entry-enter flex-shrink-0" aria-hidden="true">subdirectory_arrow_left</mat-icon>
      </a>
      }
    </div>
    }

    @if (spotlight.isEmpty()) {
    <div class="panel-empty d-flex flex-column align-items-center text-center">
      <mat-icon aria-hidden="true">search_off</mat-icon>
      <span>{{ 'app.home.spotlight.empty' | translate: { query: spotlight.query() } }}</span>
      @if (!spotlight.canSearchDirectory()) {
      <span class="empty-hint">{{ 'app.home.spotlight.directory_unavailable' | translate }}</span>
      }
    </div>
    }
  </div>
  }
</div>
